export const PROFISSIONAL_SAUDE = {
    "SIM" : 1,
    "NAO" : 0,
}

export const GESTANTE = {
    "SIM" : 1,
    "NAO" : 0,
}
